import type { ReactNode } from 'react';

const icons: Record<string, ReactNode> = {
  folder: <path d="M3 7V5a1 1 0 0 1 1-1h5l2 3h9a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z" />,
  chevron: <path d="m9 5 7 7-7 7" />,
  move: <><path d="M3 7V5a1 1 0 0 1 1-1h5l2 3h9a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z" /><path d="M8 13h8m-3-3 3 3-3 3" /></>,
  document: <><path d="M14 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8Z" /><path d="M14 3v5h5M9 12h6M9 16h6" /></>,
  grid: <><rect x="4" y="4" width="16" height="16" rx="2" /><path d="M4 10h16M10 4v16M15 14h1M15 17h1M7 14h.01M7 17h.01" /></>,
  records: <><rect x="5" y="3" width="14" height="18" rx="2" /><path d="M9 8h6M9 12h6M9 16h6" /></>,
  edit: <path d="m15 5 4 4M4 20l4-1L20 7a2.8 2.8 0 0 0-4-4L4 15Z" />,
  chart: <><rect x="4" y="13" width="3" height="7" rx=".5" /><rect x="10.5" y="5" width="3" height="15" rx=".5" /><rect x="17" y="9" width="3" height="11" rx=".5" /></>,
  more: <><circle cx="5" cy="12" r="1" /><circle cx="12" cy="12" r="1" /><circle cx="19" cy="12" r="1" /></>,
  search: <><circle cx="10.5" cy="10.5" r="6.5" /><path d="m16 16 4.5 4.5" /></>,
  upload: <path d="M12 15V3m-4 4 4-4 4 4M5 14v6h14v-6" />,
  plus: <path d="M12 5v14M5 12h14" />,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  play: <path d="m8 4 12 8-12 8Z" />,
  pause: <path d="M8 5v14M16 5v14" />,
  copy: <><rect x="8" y="8" width="12" height="13" rx="2" /><path d="M16 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3" /></>,
  external: <path d="M14 3h7v7m0-7L11 13M10 4H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-5" />,
  trash: <path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7" />,
  user: <><circle cx="12" cy="7" r="3.5" /><path d="M5 21v-3a7 7 0 0 1 14 0v3Z" /></>,
  close: <path d="m6 6 12 12M6 18 18 6" />,
};

export default function AdminIcon({ name, className = '' }: { name: keyof typeof icons; className?: string }) {
  return <svg className={`admin-icon ${className}`} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">{icons[name]}</svg>;
}
